import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../partials/Header";
// import Footer from "../partials/Footer";
import Utils from "../../../utils";

function Layout() {
    const [themeClass, setThemeClass] = useState('');
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const location = useLocation();

    const shouldHideHeader = location.pathname.startsWith('/manage/my-files/document-summary');

    useEffect(() => {
        const interval = setInterval(() => {
            const userData = Utils.loginUserData();
            if (Object.keys(userData).length > 0) {
                setThemeClass(userData.theme_color || '');
            }
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={`wrapper ${themeClass}`}>
            <div className="dashboard-layout">
                {/* Sidebar */}
                <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
                    {!shouldHideHeader && (
                        <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
                    )}
                </div>

                {/* Main Content */}
                <div className={`main-content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                    <Outlet />
                </div>
            </div>

            {/* <Footer /> */}
        </div>
    );
}

export default Layout;
